import ApiService from "@/services/ApiService";
import { ROTAS_API_ORGANOGRAMA } from "../types/organograma.types";
import type { AcessoOrganograma } from "../types/organograma.types";

/** Perfil do usuário logado e os níveis que ele abre. */
export const buscarAcessoOrganograma = async (): Promise<AcessoOrganograma> => {
  const { data } = await ApiService.get(ROTAS_API_ORGANOGRAMA.acesso);
  return (data as { data: AcessoOrganograma }).data;
};
